<template>
    <div id="BreathingContainer">
        <div class="sv_q sv_qstn" style="width: 100%;">
            <h5 class="sv_q_title">
                <div class="message" :class="{'hidden':step!=0}">Let's begin by listening to your&nbsp;heart.</div>
                <div class="message" :class="{'hidden':step!=2}">Breathe in time with the circle&nbsp;below.</div>
            </h5>
        </div>
        <transition name="fade">
            <div class="timer-holder" :class="{active:step==2}">
                <svg width="80" height="80" class="pie">
                    <circle r="40" cx="40" cy="40" class="circle"/>
                    <circle id="slice" r="20" cx="40" cy="40" class="circle  percent-10"/>
                </svg>
            </div>
        </transition>

        <div class="breath-container" :class="{initial:initial}">
            <div class="breather">
                <div class="orb1 breathing" :class="['step-'+step]">
                    <template v-if="step == 0 && !error">
                        <div class="message">Place your finger in the&nbsp;sensor. Keep your hand flat.</div>
                        <div class="oximeter">
                            <div class="arrow"></div>
                        </div>
                    </template>
                    <template v-if="step != 0 && !error">
                        <div class="message darkMessage">Perfect! Please stay like that for 60 seconds</div>
                    </template>
                </div>
                <div class="orbs orb2"></div>
                    <div class="orbs orb3"></div>
                    <div class="orbs orb4"></div>
                    <div class="orbs orb5"></div>
                    <div class="orbs orb6"></div>
                    <div class="orbs orb7"></div>
                    <div class="orbs orb8"></div>
            </div>
            <div class="swirl-holder" :class="{active:step!=0}">
                <svg id="swirl-outer" data-name="swirl-outer" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 600.34 603.41">
                <rect class="outer-boy" width="600.34" height="603.41"/>
                <g>
                    <g class="dimmer">
                    <path class="swirl-obj swirly1" d="M525.75,451.4c-13.4,20-31.17,36.21-48.46,51.37a267.44,267.44,0,0,1-58.46,38.92c-21.18,10.39-44.18,14.81-67.16,19.36s-45.63,4.67-69.17,3.12c-23.2-1.52-47.71,1.6-70.22-6.08-21.77-7.43-42.44-20-62.46-33.41s-35.49-31.26-50.65-48.55C83.49,458.24,73.19,437.83,63,417c-10.4-21.17-26.85-40.53-31.4-63.51s.7-47.32,2.24-70.86C35.31,259.39,40.3,237,48,214.48c7.42-21.76,14.43-44.29,27.82-64.3A270.16,270.16,0,0,1,122.52,97.5c17.89-15.69,38.64-26.8,59.51-37,21.17-10.4,43.27-17.09,66.25-21.64s46.3-11.94,69.83-10.39a274.35,274.35,0,0,1,69.77,13.88c21.76,7.43,41,22.19,61.06,35.58s38.8,27.54,54,44.83a268.61,268.61,0,0,1,39.26,58.44c10.4,21.17,17.2,43.91,21.75,66.9s10.42,46.82,8.88,70.36c-1.52,23.2-14.41,44.69-22.09,67.21C543.27,407.39,539.15,431.38,525.75,451.4Z"/>
                    </g>
                    <g class="dimmer">
                    <path class="swirl-obj swirly2" d="M575.47,317.65c-1.6,24-14.07,46.61-21.47,68.38a267,267,0,0,1-31.22,62.9c-13.14,19.59-35,30.12-52.66,45.55s-37,23.43-58.18,33.86c-20.86,10.28-35.19,39.85-58.53,44.46-22.56,4.45-48.15-.47-72.18-2.06S236.36,555.38,214.59,548c-22.53-7.66-37.65-24.15-57-37.1-19.58-13.14-55.93-7.51-71.36-25.13s-12-49.47-22.46-70.62c-10.28-20.86-15.59-41.88-20.2-65.22-4.45-22.56-16.83-44.59-15.23-68.62s7.53-47.37,14.93-69.14c7.65-22.53,23.82-40.28,36.77-59.59C93.22,133,109.32,117.89,127,102.46s27.87-43.31,49-53.74a288,288,0,0,1,69-23.49c22.56-4.45,47.78,8.19,71.81,9.79s47.89.7,69.66,8.1c22.53,7.66,44.45,17.71,63.76,30.66,19.59,13.14,35.92,30.77,51.35,48.4s40.18,31.51,50.61,52.66c10.29,20.85-6.26,51.36-1.65,74.7C555,272.1,577.06,293.62,575.47,317.65Z"/>
                    </g>
                    <g class="dimmer">
                    <path class="swirl-obj swirly3" d="M530.89,456c-13.4,20-39.8,30.44-57.09,45.6a267.08,267.08,0,0,1-58.52,38.81c-21.17,10.39-46.61,2.32-69.6,6.87s-41.93-1.12-65.47-2.66c-23.2-1.52-53.09,32.23-75.61,24.55-21.76-7.43-40.49-28.93-60.5-42.33s-26.87-40.2-42-57.49C86.39,451.46,87,428.18,76.75,407.31c-10.4-21.17-62.53-28.41-67.08-51.39S37.62,305.54,39.16,282c1.52-23.2,8.34-42.53,16-65,7.42-21.76,1-49.76,14.42-69.78s31-37,48.29-52.15c17.89-15.68,42.89-19.15,63.76-29.39,21.17-10.4,42.07-13.74,65-18.29S292,12.15,315.51,13.69a302.07,302.07,0,0,1,73.31,14.46c21.76,7.42,33.53,39.78,53.54,53.18s43.43,21.58,58.58,38.88c15.68,17.89,30.27,37.54,40.51,58.42,10.4,21.17,14.26,45.31,18.81,68.29s27.65,47.92,26.11,71.45c-1.52,23.2-47.79,38-55.48,60.52C523.47,400.66,544.29,436,530.89,456Z"/>
                    </g>
                </g>
                </svg>
            </div>
        </div>
    </div>
</template>

<script>
import db from '../db'

export default {
    name: 'Intro',
    props: ['value', 'content'],
    mixins: [],
    data() {
        return {
            initial: true,
            error: false,
            step: 0,
            rate: 10,
            sensorRef: null,
            values: {
                hrv: 0,
                hr: 0, 
                bp: '55/75',
            },
            clock: null,
            connected: false,
            ready: false,
            hasHRV: this.$isBooth,
            timerRad: 40
        }
    },

    components: {
    },
    ready() {
    },
    methods: {
        updateSelection: function () {
            this.$emit('input', this.values);
        },
        sensorReading(values) {
            
            if (this.connected && this.ready) {
                if (values.hrv) this.values.hrv = values.hrv
                if (values.heart_rate) this.values.hr = values.heart_rate
                if (this.step < 1 && this.values.hrv != 0) {
                    this.gotoStep()
                }
            }
            if (values.status == "connected" && !this.connected) {
                this.connected = true
            }

            // NO BP
            console.log(this.values)
        },
        gotoStep() {
            this.$breatheAudio(true)
            this.$sound('finger')
            setTimeout(() => {
                this.step = 1
                setTimeout(() => {
                    this.listen()
                }, 4000)
            }, 100)
        },
        listen() {
            this.step = 2
            let dest = Math.PI*2*this.timerRad
            this.clock = this.$anime({
                targets: '#slice',
                strokeDasharray: dest,
                easing: 'linear',
                duration: 60000,
                complete: (anim) => {
                    this.$anime.remove(this.clock)
                    this.clock = null
                    // End breathing sounds
                    this.$breatheAudio(false)
                    // Disable sensor
                    if (this.hasHRV) {
                        this.sensorRef.off()
                        db.ref(`sensors/hrv_sensor/CMD_disconnect`).set(true)
                    }
                    // Update model
                    this.$emit('input', this.values)
                }
            })
        }
    },

    computed: {
        message() {
            return ""
        }
    },

    watch: {
    },

    created() {
    },

    destroyed() {
        this.$breatheCancel()
    },

    mounted() {
        if (this.hasHRV) {
            console.log("SENSOR RESET")
            db.ref(`sensors/hrv_sensor/CMD_new_user`).set(true, () => {
                this.sensorRef = db.ref('sensors/hrv_sensor')
                this.sensorRef.on('value', (snapshot) => {
                    this.sensorReading(snapshot.val())
                })
                setTimeout(() => {
                    this.ready = true
                }, 4000)
                setTimeout(() => {
                    console.log("ERROR: Skip sensor");
                    if (this.step < 1) {
                        this.gotoStep()
                    }
                }, 15000)
            })
        } else {
            
            this.$nextTick(() => {
                // Enable sensor
                setTimeout(() => {
                    this.gotoStep()
                }, 3000)
            })
        }
    }

}
</script>

<style lang="scss">
@import "../styles/variables.scss";

@keyframes insert {
    0% {
    bottom: -80px;
    opacity: 0;
  }
  20% {
    bottom: -80px;
    opacity: 0;
  }
  75% {
    bottom: 0;
    opacity: 1;
  }
  100% {
    bottom: 0;
    opacity: 0;
  }
}


#BreathingContainer {
    // VARS
    $radialVal: 4rem;
    $scaleFactor: 1.5;
    $swirlSize:52rem;
    $glass: .3;

    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    padding: 8vw;
    padding-top: 33vw;
    margin:0 auto;
    .hidden {
        opacity: 0;
        display: none;
    }
    .sv_q_title {
        height: 30vw;
    }
    .breath-container {
        position:relative;
        display:flex;
        flex-direction:column;
        align-items:center;
        align-content:center;
        justify-items:center;
        justify-content:center;
        width:100%;
        height:$swirlSize;
    }
    @keyframes breather {
        0% {
            width:$radialVal * 8;
            height:$radialVal * 8;
            background-color: rgba($color-white, .35);
        }
        50% {
            width:$radialVal;
            height:$radialVal;
            background-color: rgba($color-white, 1);
        }
        100% {
            width:$radialVal * 8;
            height:$radialVal * 8;
            background-color: rgba($color-white, .35);
        }
    }
    .breather {
        width:20rem;
        height:20rem;
        position:absolute;
        display:flex;
        flex-direction:column;
        align-items:center;
        align-content:center;
        justify-items:center;
        justify-content:center;
        transform:scale(1.3);
        backface-visibility: hidden;
        z-index:5;
    }

    .breathing {
        z-index: 8;
        position:absolute;
        display:flex;
        flex-direction:column;
        align-items:center;
        justify-content:center;
        width:$radialVal * 8;
        height:$radialVal * 8;
        background-color: $color-white;
        border-radius:20rem;
        transition:all 1s ease;
        border: solid 4px transparent;
        .message {
            text-align: center;
            padding: 2vw 8vw 0;
            font-size: 3vw;
            color: $color-white;
            font-weight: 500;
            transition:opacity .5s ease;
        }
        .darkMessage {
            color: $color-dark;
        }
        .oximeter {
            width: 8vw;
            height: 16vw;
            border: 4px solid $color-dark;
            border-radius: 4vw;
            position: relative;
            margin-top: 3vw;
            .arrow {
                position: absolute;
                bottom: 0;
                width: 8vw;
                height: 8vw;
                background-image: url(../assets/static/BackArrow.svg);
                background-repeat: no-repeat;
                background-position: center center;
                background-size: 60%;
                transform: rotate(90deg);
                animation-duration: 1.5s;
                animation-name: insert;
                animation-delay: 300;
                animation-timing-function: ease-out;
                animation-iteration-count: infinite;
            }
        }
        &.step-0 {
            background-color: $color-blue;
            border: solid 4px $color-white;
        }
        &.step-1 {
            background-color: rgba($color-white, .35);
        }
        &.step-2 {
            background-color: rgba($color-white, .35);
            animation-duration: 6s;
            animation-name: breather;
            animation-delay: 2s;
            animation-timing-function: ease-in-out;
            animation-iteration-count: infinite;
            .message {
                opacity: 0;
            }
        }
    }

    button {
        background:white;
        box-shadow:none;
        font-family:helvetica-bold;
        padding:.75rem;
        width:10rem;
        margin-top:3rem;
        border-radius:.5rem;
        border:none;
        font-size:1.1rem;
        color:#444;
        transition:all .5s ease;
        &:focus {
            outline:none;
        }
    }

    .swirl-holder {
        position:absolute;
        width:$swirlSize;
        height:$swirlSize;
        filter:blur(20px);
        transition:all .5s ease;
        opacity: 0;
        &.active {
            opacity: 1;
        }
    }

    .orbs {
        border-radius:20rem;
        position:absolute;
        transition:all .5s ease;
        border: solid 4px $color-white;
        background-color:$color-white;
    }

    .orbs:nth-of-type(2){
        width:$radialVal * 2;
        height:$radialVal * 2;
        z-index:7;
        opacity: .5;
    }
    .orbs:nth-of-type(3){
        width:$radialVal * 3;
        height:$radialVal * 3;
        z-index:6;
        opacity: .4;
    }
    .orbs:nth-of-type(4) {
        width:$radialVal * 4;
        height:$radialVal * 4;
        z-index:5;
        opacity: $glass;
    }
    .orbs:nth-of-type(5) {
        width:$radialVal * 5;
        height:$radialVal * 5;
        z-index:4;
        opacity: $glass;
    }
    .orbs:nth-of-type(6) {
        width:$radialVal * 6;
        height:$radialVal * 6;
        z-index:3;
        opacity: $glass;
    }
    .orbs:nth-of-type(7) {
        width:$radialVal * 7;
        height:$radialVal * 7;
        z-index:2;
        opacity: $glass;
    }
    .orbs:nth-of-type(8) {
        width:$radialVal * 8;
        height:$radialVal * 8;
        z-index:1;
        opacity: $glass;
    }

    .swirly1 {
        animation-name: swirl;
        animation-duration: 18s;
        animation-timing-function: linear;
        animation-delay: 0s;
        animation-iteration-count: infinite;
        animation-direction: forwards;
        animation-fill-mode: forwards;
        animation-play-state: running;
        transition:all .5s ease;
        transform-origin:center center;
        transform:rotate(0deg);
        transform-box: fill-box;
    }
    .swirly2{
        animation-name: swirl;
        animation-duration: 20s;
        animation-timing-function: linear;
        animation-delay: 0s;
        animation-iteration-count: infinite;
        animation-direction: reverse;
        animation-fill-mode: forwards;
        animation-play-state: running;
        transition:all .5s ease;
        transform-origin:center center;
        transform:rotate(0deg);
        transform-box: fill-box;
    }
    .swirly3 {
        animation-name: swirl;
        animation-duration: 18s;
        animation-timing-function: linear;
        animation-delay: 0s;
        animation-iteration-count: infinite;
        animation-direction: forwards;
        animation-fill-mode: forwards;
        animation-play-state: running;
        transition:all .5s ease;
        transform-origin:center center;
        transform:rotate(0deg);
        transform-box: fill-box;
    }

    @keyframes swirl {
        0% {
            transform:rotate(0deg);
        }
            100% {
            transform:rotate(360deg);
        }
    }

    .timer-holder {
       
        margin: 0 auto;
        margin-top: -10vw;
        width:8vw;
        height:8vw;
        // transform: rotate(-90deg);
        opacity: 0;
        transition: opacity 1s ease;
        &.active {
            opacity: 1;
        }
        .pie {
            $radius: 40;
            $circ: pi()*$radius;
            transform: rotate(-90deg);
            .circle {
                fill: #09A6B1;
            }
            #slice {
                stroke: white;
                stroke-dasharray: $circ;
                stroke-dashoffset: $circ;
                stroke-width: $radius;
            }
        }
    }

    .timestroke{
        stroke-dasharray: 204;
        stroke-dashoffset: 204;
    }

    .timerback {
        display: inline-block;
    }

    // IMPORTS
    .swirl-obj, .outer-boy {
        fill:#CDF9FC;
    }
    .outer-boy {
        opacity: 0;
    }
    .dimmer {
        opacity: 0.2;
    }
    .timerback {
        fill:#09A6B1;
    }
    .timecircles {
        fill:#FFF;
        opacity: .5;
    }
    .timestroke {
        fill:none;
        stroke:$color-white;
        stroke-width:16;
        stroke-linecap:round;
    }
}

</style>